module.exports = __webpack_public_path__ + "img/done.8b031db9.png";